import React from 'react';
import { Container } from 'react-bootstrap';

const principals = [
  {
    name: 'Sam Baron',
    title: 'Founding Principal · AI Solutions Architect',
    bio: 'Sam is a serial entrepreneur and outcomes-focused AI solutions architect who has spent two decades building ecommerce operations inside real businesses. He started in 2004 importing live tropical fish from Southeast Asia and selling them online, then spent 15 years in designer menswear, selling globally across major marketplaces. Along the way, he worked with legacy distribution companies in HVAC, plumbing supply, CPG, and specialty retail, building marketplace strategy, operational systems, and digital revenue channels. In 2020, he co-founded Shop the King and helped build the Topicz ecommerce operation from the ground up, turning legacy distribution knowledge into modern marketplace infrastructure that teams can actually run.',
    initials: 'SB',
    photo: '/principals/sam-baron.jpg'
  }
  // Add additional principals here as the team grows.
];

const Principals = () => {
  return (
    <section className="wn-section wn-section-soft" id="principals">
      <Container>
        <div className="text-center wn-fade-in">
          <div
            className="wn-section-label"
            style={{ justifyContent: 'center' }}
          >
            <span className="label-dot" />
            Our Principals
          </div>
          <h2 className="wn-section-title centered">
            You work directly with a{' '}
            <span className="wn-gradient-text">principal — every time.</span>
          </h2>
          <p className="wn-section-subtitle centered">
            No handoffs to a junior team. The people who've done this work are
            the people in the room with you.
          </p>
        </div>

        <div className="wn-principals-grid wn-fade-in wn-fade-in-delay-1">
          {principals.map((p, i) => (
            <div key={i} className="wn-principal-card">
              <div
                className={`wn-principal-avatar ${p.photo ? 'has-photo' : ''}`}
                style={
                  p.photo
                    ? {
                        backgroundImage: `url(${process.env.PUBLIC_URL}${p.photo})`
                      }
                    : undefined
                }
                aria-label={`${p.name} headshot`}
              >
                {!p.photo && p.initials}
              </div>
              <h3>{p.name}</h3>
              <div className="wn-principal-title">{p.title}</div>
              <p>{p.bio}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Principals;
